import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb } from 'geniebook-ui/dist';
import { BreadcrumbItemsProp } from 'geniebook-ui/dist/components/Breadcrumb';
import { useAtomValue } from 'jotai';
import {
  isExpiredAtom,
  planDetailAtom,
  subjectSubscriptionAtom,
  userDetailAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import SubscriptionCardNavigation from '@components/subscription/detail/SubscriptionCardNavigation';
import SubscriptionDetailCard from '@components/subscription/detail/SubscriptionDetailCard';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import HintPaymentCard from '@components/subscription/detail/hint/HintPaymentCard';
import { COUNTRY_ID_SINGAPORE } from '@utils/constants/countries.constants';
import { hintAddOnQueryAtom } from '@components/subscription/store/HintPaymentAtoms';

const SubscriptionDetail = () => {
  const subjectSubscription = useAtomValue(subjectSubscriptionAtom);
  const planDetail = useAtomValue(planDetailAtom);
  const navigate = useNavigate();
  const isSelectedExpired = useAtomValue(isExpiredAtom);
  const userDetail = useAtomValue(userDetailAtom);
  const isHintPaymentIsOn = useFeatureIsOn('student_hint_payment');
  const hintDetailQuery = useAtomValue(hintAddOnQueryAtom);

  useEffect(() => {
    if (isSelectedExpired) {
      navigate('plan-overview', { replace: true });
    }
  }, [isSelectedExpired]);

  const breadcrumbItems: BreadcrumbItemsProp[] = [
    {
      title: 'Subject',
      onClick: () => navigate('/subscription'),
    },
    {
      title: subjectSubscription?.display_name ?? '',
    },
  ];

  if (!subjectSubscription || !planDetail || !userDetail) {
    return null;
  }

  return (
    <div>
      <div className={'mb-6 max-lg:hidden'}>
        <Breadcrumb
          className={'[&_svg:first-of-type]:hidden'}
          items={breadcrumbItems}
        />
      </div>
      <SubscriptionCardNavigation
        subscription={subjectSubscription}
        planDetail={planDetail}
        className={'mb-6'}
      />
      <div className={'grid grid-cols-2 lg:gap-6 max-lg:gap-4'}>
        <div className={'md:col-span-1 max-md:col-span-2 last:!col-span-2'}>
          <SubscriptionDetailCard
            subscription={subjectSubscription}
            planDetail={planDetail}
            userDetail={userDetail}
          />
        </div>
        {isHintPaymentIsOn &&
          !hintDetailQuery.data?.data.error &&
          Number(userDetail.country_id) == COUNTRY_ID_SINGAPORE && (
            <div className={'md:col-span-1 max-md:col-span-2'}>
              <HintPaymentCard />
            </div>
          )}
      </div>
    </div>
  );
};

export default SubscriptionDetail;
